import React from 'react';
import PropTypes from 'prop-types';
import { AutoComplete, RaisedButton } from 'material-ui';
import { getFieldForHeader } from '../helpers/fields';
import { FIELDS_BUILT_IN } from '../constants';

const INITIAL_STATE = {
  valueLabel: null,
  searchTextLabel: '',
  valuePosition: null,
  searchTextPosition: ''
};

class FieldAdderWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE
    };
  }

  _onSelectItemLabel = (data, index) => {
    if (index === -1) {
      this.setState({ searchTextLabel: data });
    } else {
      this.setState({ valueLabel: data });
    }
  };

  _onSelectItemPosition = (data, index) => {
    if (index === -1) {
      this.setState({ searchTextPosition: data });
    } else {
      this.setState({ valuePosition: data });
    }
  };

  _getPosition = () => {
    if (this.state.valuePosition || this.state.searchTextPosition.length) {
      let value;
      if (this.state.valuePosition) {
        value = this.state.valuePosition;
      } else {
        value = this.state.searchTextPosition;
      }
      if (value === 'begin') {
        return 0;
      }
      if (value === 'end') {
        return 1000;
      }
      return ~~value;
    }
  };

  _onAddField = () => {
    if (this.state.valueLabel || this.state.searchTextLabel.length) {
      this.props.onChange({
        newField: getFieldForHeader(
          this.state.valueLabel
            ? this.state.valueLabel.text || this.state.valueLabel
            : this.state.searchTextLabel,
          'string'
        ),
        position: this._getPosition()
      });
      this.setState({ ...INITIAL_STATE });
    }
  };

  _onUpdateInputLabel = searchTextLabel => {
    this.setState({ searchTextLabel, valueLabel: null });
  };

  _onUpdateInputPosition = searchTextPosition => {
    this.setState({ searchTextPosition });
  };

  render() {
    return (
      <div>
        <div className="autocomplete-inside-bootstrap">
          <AutoComplete
            openOnFocus
            onNewRequest={this._onSelectItemLabel}
            onUpdateInput={this._onUpdateInputLabel}
            hintText="Label/Header"
            searchText={this.state.searchTextLabel}
            filter={AutoComplete.fuzzyFilter}
            dataSource={FIELDS_BUILT_IN}
          />
          <AutoComplete
            openOnFocus
            onNewRequest={this._onSelectItemPosition}
            onUpdateInput={this._onUpdateInputPosition}
            hintText="Position"
            searchText={this.state.searchTextPosition}
            dataSource={['beginning', 'end']}
          />
          <RaisedButton onClick={this._onAddField} label="Add" primary />
        </div>
      </div>
    );
  }
}
FieldAdderWidget.propTypes = {
  options: PropTypes.shape({
    enumOptions: PropTypes.arrayOf(PropTypes.string)
  }),
  onChange: PropTypes.func
};

export default FieldAdderWidget;



// WEBPACK FOOTER //
// ./src/components/FieldAdderWidget.js